import { styleFromFontWeight } from "@redotech/redo-model/brand-kit";
import { Teaser as ITeaser } from "@redotech/redo-model/signup-form";
import { memo } from "react";
import CheckCircle from "../arbiter-icon/check-circle.svg";
import { Flex } from "../flex";

export const BaseTeaser = memo(function Teaser({
  teaser,
  onClick,
}: {
  teaser: ITeaser;
  onClick: () => void;
}) {
  return (
    <Flex
      align="center"
      justify="space-between"
      onClick={onClick}
      pb="md"
      pl="xl"
      pr={teaser.iconVisible ? "3xl" : "xl"}
      pt="md"
      style={{
        backgroundColor: teaser.backgroundColor,
        borderRadius: teaser.cornerRadiusPx,
        color: teaser.textColor,
        fontFamily: teaser.fontFamily,
        fontSize: teaser.fontSizePx,
        fontWeight: styleFromFontWeight(teaser.fontWeight),
        borderWidth: teaser.borderStroke.weightPx,
        borderColor: teaser.borderStroke.color,
        borderStyle: "solid",
        pointerEvents: "auto",
        cursor: "pointer",
        zIndex: 1_000_000,
      }}
    >
      {teaser.iconVisible && (
        <CheckCircle style={{ height: "32px", width: "32px" }} />
      )}
      {teaser.text}
    </Flex>
  );
});
